import { getGupVisit, returnToGup } from '@/lib/gup';
import { Button } from '@opaz/ui-components';
import { useNavigate, useRouter } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function UniversalBackButton() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const router = useRouter();

  const handleBack = () => {
    const processId = router.state.location.pathname.match(/^\/processes\/([^/]+)/)?.[1];
    const visit = processId ? getGupVisit(processId) : undefined;
    if (visit) {
      returnToGup(visit);
      return;
    }
    if (window.history.length > 1) {
      router.history.back();
      return;
    }

    navigate({ to: '/' });
  };

  return (
    <div className="border-b border-border bg-white px-4 py-2 md:hidden">
      <Button variant="ghost" className="h-9 gap-2 px-2 no-underline" onClick={handleBack}>
        <ArrowLeft className="h-4 w-4 rtl:rotate-180" aria-hidden="true" />
        {t('common.back')}
      </Button>
    </div>
  );
}
